<template>
  <div>
    <zm-drawer
      :visible="visible"
      :title="title"
      :width="drawerWidth"
      :footer="false"
      @cancel="cancel"
    >
      <div slot="drawerBody" class="inquiry-records">
        <zm-label title="产品信息" />
        <a-row class="detail">
          <div class="detail-item">
            <div class="label">产品名称</div>
            <div class="info">{{ model.name }}</div>
          </div>
          <div class="detail-item">
            <div class="label">规格型号</div>
            <div class="info">{{ model.spec }}</div>
          </div>
          <div class="detail-item">
            <div class="label">单位</div>
            <div class="info">{{ model.unitDesc }}</div>
          </div>
        </a-row>
        <zm-label title="询价记录" />
        <zm-table
          :columns="inquiryTable.columns"
          :rowKey="(record) => record.id"
          :dataSource="inquiryTable.data"
          :pagination="inquiryPagination"
          :loading="inquiryTable.loading"
          @change="handleInquiryChange"
        ></zm-table>

        <zm-label title="采购明细" />
        <zm-table
          :columns="purchaseTable.columns"
          :rowKey="(record) => record.id"
          :dataSource="purchaseTable.data"
          :pagination="purchasePagination"
          :loading="purchaseTable.loading"
          @change="handlePurchaseChange"
        ></zm-table>
      </div>
    </zm-drawer>
  </div>
</template>

<script>
import { getInquiryRecords, getPurchaseRecords } from '@/api/inquiry'
import moment from 'moment'
export default {
  name: 'inquiryDetail',
  computed: {
    drawerWidth () {
      const width = window.innerWidth - 200
      return width
    }
  },
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      visible: false,
      model: {},

      // 询价相关
      inquiryPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      inquiryTable: {
        data: [
          { id: 1, inquiryTime: '2021-10-29', inquiryPrice: 19.21 },
          { id: 2, inquiryTime: '2021-10-29', inquiryPrice: 19.21 },
          { id: 3, inquiryTime: '2021-10-29', inquiryPrice: 19.21 }
        ],
        columns: [
          {
            title: '询价日期',
            dataIndex: 'inquiryTime',
            customRender: (text) => {
              if (text) return moment(text).format('YYYY-MM-DD')
            },
            width: '14%'
          },
          {
            title: '询价单价(元)',
            dataIndex: 'inquiryPrice',
            width: '14%'
          },
          {
            title: '供应商',
            dataIndex: 'supplierName',
            ellipsis: true,
            width: '20%'
          },
          {
            title: '联系人',
            dataIndex: 'supplierContactName',
            width: '15%'
          },
          {
            title: '联系方式',
            dataIndex: 'phone',
            width: '17%'
          },
          {
            title: '市场商机',
            dataIndex: 'marketName',
            ellipsis: true,
            width: '20%'
          }
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      },

      // 采购相关
      purchasePagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      purchaseTable: {
        data: [
          { id: 1, inquiryTime: '2021-10-29', inquiryPrice: 19.21 },
          { id: 2, inquiryTime: '2021-10-29', inquiryPrice: 19.21 },
          { id: 3, inquiryTime: '2021-10-29', inquiryPrice: 19.21 }
        ],
        columns: [
          {
            title: '项目名称',
            dataIndex: 'projectName',
            width: '20%'
          },
          {
            title: '采购单价(元)',
            dataIndex: 'price',
            width: '13%'
          },
          {
            title: '采购数量',
            dataIndex: 'num',
            width: '12%'
          },
          {
            title: '采购日期',
            dataIndex: 'createTime',
            customRender: (text) => {
              if (text) return moment(text).format('YYYY-MM-DD')
            },
            width: '14%'
          },
          {
            title: '供应商',
            dataIndex: 'supplierName',
            ellipsis: true,
            width: '15%'
          },
          {
            title: '联系人',
            dataIndex: 'supplierContactName',
            width: '12%'
          },
          {
            title: '联系方式',
            dataIndex: 'phone',
            width: '14%'
          }
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
      if (flag) {
        this.initInquiryData()
        this.initPurchaseData()
      } else {
        this.formClear()
      }
    },
    setModelInfo () {},
    formClear () {
      this.inquiryPagination.current = 1
      this.inquiryTable.data = []
      this.purchasePagination.current = 1
      this.purchaseTable.data = []
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 获取询价记录
    async initInquiryData () {
      const params = {
        productId: this.model.id,
        pageNum: this.inquiryPagination.current,
        pageSize: this.inquiryPagination.pageSize
      }
      this.inquiryTable.loading = true
      const res = await getInquiryRecords(params).catch((error) => {
        console.log('获取失败', error)
        this.$message.error('数据获取失败，请稍后重试！')
      })
      this.inquiryTable.loading = false
      if (res.status === 0) {
        this.inquiryTable.data = res.data.list
        this.inquiryPagination.total = res.data.total
      } else {
        this.$message.warning(res.info.message)
      }
    },
    handleInquiryChange (pagination) {
      this.inquiryPagination.current = pagination.current
      this.inquiryPagination.pageSize = pagination.pageSize
      this.initInquiryData()
    },
    // 获取采购明细
    async initPurchaseData () {
      const params = {
        inquiryProductId: this.model.id,
        pageNum: this.purchasePagination.current,
        pageSize: this.purchasePagination.pageSize
      }
      this.purchaseTable.loading = true
      const res = await getPurchaseRecords(params).catch((error) => {
        console.log('获取失败', error)
        this.$message.error('数据获取失败，请稍后重试！')
      })
      this.purchaseTable.loading = false
      if (res.status === 0) {
        this.purchaseTable.data = res.data.list
        this.purchasePagination.total = res.data.total
      } else {
        this.$message.warning(res.info.message)
      }
    },
    handlePurchaseChange (pagination) {
      this.purchasePagination.current = pagination.current
      this.purchasePagination.pageSize = pagination.pageSize
      this.initPurchaseData()
    },
  }
}
</script>

<style lang="less">
.inquiry-records{
  .zm-label{
    margin-top: 32px;
    margin-bottom: 12px;
  }
  .zm-label:first-child{
    margin-top: 0;
  }
  .detail{
    display: flex;
    .detail-item{
      display: flex;
      .label{
        color: #B3B3B3;
        margin-right: 12px;
      }
      .info{
        margin-right: 100px;
      }
    }
  }
  .action-btn{
    margin-bottom: 16px;
  }
}
</style>
